import { SaveButton } from "components/Buttons"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, FormFeedback, Input, Row } from "reactstrap"
import { getBookingCalendars, refundBooking } from "store/actions"

const RefundBookingForm = ({
  booking,
  onClose,
  refundBooking,
  getBookingCalendars,
}) => {
  const [amountInput, setAmountInput] = useState(0)
  const [maxRefundAmount, setMaxRefundAmount] = useState(0)

  useEffect(() => {
    if (booking?.stripe_payment) {
      const refuded = booking?.stripe_payment?.refunded_amount || 0
      setMaxRefundAmount((booking?.stripe_payment?.amount - refuded) / 100)
    }
  }, [booking])

  useEffect(() => {
    return () => {
      setAmountInput(0)
    }
  }, [])

  return (
    <React.Fragment>
      {booking?.stripe_payment?.partial_refund && (
        <Row className="mb-2">
          <Col>
            <span>Total amount: ${booking?.stripe_payment?.amount / 100}</span>{" "}
            <br />
            <span>
              Amount refunded: ${booking?.stripe_payment?.refunded_amount / 100}
            </span>{" "}
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <span>Amount to refund:</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <span style={{ fontSize: "10px" }}>
            (full refund amount: <label>${maxRefundAmount}</label>)
          </span>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <Input
            type="number"
            value={amountInput}
            min={0}
            onChange={e =>
              setAmountInput(
                e?.target?.value
                  ? parseFloat(e?.target?.value)
                  : e?.target?.value
              )
            }
            invalid={amountInput > maxRefundAmount || !amountInput.toString()}
            step={0.01}
          />
          <FormFeedback>
            <div className="mt-3">
              {!amountInput
                ? "The refund amount is required"
                : `The refund amount must be under ${maxRefundAmount}`}
            </div>
          </FormFeedback>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center mt-3">
        <Col xs="auto">
          <SaveButton type="button" content="Cancel" onClick={onClose} />
        </Col>
        <Col xs="auto">
          <SaveButton
            disabled={
              amountInput === 0 ||
              amountInput > maxRefundAmount ||
              !amountInput.toString()
            }
            type="button"
            content="Refund"
            color="danger"
            onClick={() => {
              refundBooking({
                values: {
                  amount: amountInput,
                  booking_id: booking?.id,
                  full_refund:
                    amountInput * 100 === booking?.stripe_payment?.amount,
                },
                callback: () => {
                  onClose()
                  getBookingCalendars({ type: 2 })
                },
              })
            }}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapDispatchToProps = dispatch => ({
  refundBooking: values => dispatch(refundBooking(values)),
  getBookingCalendars: values => dispatch(getBookingCalendars(values)),
})

export default connect(null, mapDispatchToProps)(RefundBookingForm)
